export default function (child, targetComponent) {
    // @ts-ignore
    return child?.type?.displayName === targetComponent.displayName;
}
//# sourceMappingURL=isComponent.js.map